<template>
  <v-card 
    rounded="0" 
    theme="dark" 
    @mouseenter="!$vuetify.display.mdAndDown && handleExpandMenu(true)" 
    @mouseleave="!$vuetify.display.mdAndDown && handleExpandMenu(false)" 
    height="100vh" 
    class="bg-dark mx-auto overflow-auto"
  >
    <div>
      <div style="height: 100px" class="d-flex justify-content-center align-items-center">
        <v-img v-show="expandMenu" transition="fade-transition" :src="logo" style="max-width: 190px" :title="version" />

        <v-img v-show="!expandMenu" transition="fade-transition" :src="require('@/assets/images/logo-mini.png')" contain height="40%" :title="version" />
      </div>

      <v-divider class="mt-0"></v-divider>
    </div>

    <div style="scroll-margin-top: 100px" v-for="item in items" :key="item.title">
      <v-list density="default" class="pt-1 pb-1" v-if="item.visible" nav>
        <v-list-group v-if="item.visible && 'items' in item && item.items.length > 0" v-model="item.active" :key="item.title" no-action>
          <template v-slot:activator="{ props }">
            <v-list-item dense v-bind="props" :title="item.title">
              <template v-slot:prepend> <font-awesome-icon :icon="item.icon" class="sidebar-icon mr-1" /> </template>
            </v-list-item>
          </template>

          <router-link v-for="subItem in item.items" :key="subItem.title" :to="'/' + subItem.path">
            <v-list-item :class="expandMenu ? 'subitem text-white' : 'subitem text-white hidden'" v-if="subItem.visible" ripple @click="close">
              <template v-slot:prepend>
                <font-awesome-icon v-if="subItem.icon != ''" :icon="subItem.icon" class="sidebar-icon mr-1" />
              </template>
              <v-list-item-title>{{ subItem.title }}</v-list-item-title>
            </v-list-item>
          </router-link>
        </v-list-group>

        <router-link v-else-if="item.visible" :to="'/' + item.path">
          <v-list-item :active="item.path.includes($route.path)" dense class="text-white pl-1" :key="item.title" link>
            <template v-slot:prepend> <font-awesome-icon :icon="item.icon" class="sidebar-icon mr-1" /> </template>

            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </router-link>
      </v-list>
    </div>
  </v-card>
</template>

<script>
import Constant from "@/constants/sections";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import UserTypeConstant from "@/constants/user_type.js";
import { version } from "../../package.json";
export default {
  mixins: [GenericMixin, RolMixin],
  RolMixin,
  data() {
    return {
      version: version,
      isExternal: null,
      clientItems: [
        /*{ title: "Monitoreo", icon: "desktop", path: Constant.SECTION_MONITORING, visible: false, active: false },*/
        {
          title: "Recepción",
          icon: "arrow-right",
          active: false,
          visible: false,
          items: [{ title: "ASN", icon: "", path: Constant.SECTION_ASN, visible: false }],
        },
        {
          title: "Expedición",
          icon: "arrow-left",
          active: false,
          visible: false,
          items: [
            { title: "Ordenes de envio", icon: "", path: Constant.SECTION_SHIPMENT_ORDERS, visible: false },
            { title: "Olas de preparacion", icon: "", path: Constant.SECTION_WAVE, visible: false },
            { title: "Punto de entrega", icon: "", path: Constant.SECTION_SUBCLIENTS, visible: false },
          ],
        },
        {
          title: "Inventario",
          icon: "boxes-stacked",
          active: false,
          visible: false,
          items: [
            { title: "Inventario", icon: "", path: Constant.SECTION_INVENTORY + "/atributos", visible: false },
            { title: "Productos", icon: "", path: Constant.SECTION_PRODUCTS, visible: false },
            { title: "Rubros", icon: "", path: Constant.SECTION_RUBROS, visible: false },
            { title: "Subrubros", icon: "", path: Constant.SECTION_SUBRUBROS, visible: false },
            { title: "Proveedores", icon: "", path: Constant.SECTION_SUPPLIER, visible: false },
          ],
        },
        { title: "Reportes", icon: "file", path: Constant.SECTION_REPORTS, visible: false, active: false },
      ],
      allItems: [
        { title: "Monitoreo", icon: "desktop", path: Constant.SECTION_MONITORING, visible: false, active: false },
        {
          title: "Recepción",
          icon: "arrow-right",
          active: false,
          visible: false,
          items: [{ title: "ASN", icon: "", path: Constant.SECTION_ASN, visible: false }],
        },
        {
          title: "Expedición",
          icon: "arrow-left",
          active: false,
          visible: false,
          items: [
            { title: "Ordenes de envio", icon: "", path: Constant.SECTION_SHIPMENT_ORDERS, visible: false },
            { title: "Olas de preparacion", icon: "", path: Constant.SECTION_WAVE, visible: false },
            { title: "Preparación de envios", icon: "", path: Constant.SECTION_PICKING_DETAIL, visible: false },
            { title: "Gestion de picking", icon: "", path: Constant.SECTION_PICKING_MANAGEMENT, visible: false },
            { title: "Empaquetar", icon: "", path: Constant.SECTION_PACKAGES, visible: false },
          ],
        },
        { title: "Tareas", icon: "list-check", path: Constant.SECTION_TASKS, visible: false, active: false },
        {
          title: "Inventario",
          icon: "boxes-stacked",
          active: false,
          visible: false,
          items: [
            { title: "Por LPN", icon: "", path: Constant.SECTION_INVENTORY + "/lpn", visible: false },
            { title: "Por Ubicacion", icon: "", path: Constant.SECTION_INVENTORY + "/ubicacion", visible: false },
            { title: "Por Atributos", icon: "", path: Constant.SECTION_INVENTORY + "/atributos", visible: false },
            { title: "Ajuste manual", icon: "", path: Constant.SECTION_AJUSTE_MANUAL, visible: false },
          ],
        },
        { title: "LPNs", icon: "barcode", path: Constant.SECTION_LPN, visible: false, active: false },
        {
          title: "Productos",
          icon: "box",
          path: Constant.SECTION_PRODUCTS,
          visible: false,
          active: false,
          items: [
            { title: "Productos", icon: "", path: Constant.SECTION_PRODUCTS, visible: false },
            { title: "Rubros", icon: "", path: Constant.SECTION_RUBROS, visible: false },
            { title: "Subrubros", icon: "", path: Constant.SECTION_SUBRUBROS, visible: false },
            { title: "Proveedores", icon: "", path: Constant.SECTION_SUPPLIER, visible: false },
            { title: "Tipos de producto", icon: "", path: Constant.SECTION_PRODUCT_TYPES, visible: false },
            { title: "Reglas", icon: "", path: Constant.SECTION_STORAGE_RULES, visible: false },
          ],
        },
        {
          title: "Clientes",
          icon: "users",
          active: false,
          visible: false,
          items: [
            { title: "Clientes", icon: "", path: Constant.SECTION_CLIENTS, visible: false },
            { title: "Punto de entrega", icon: "", path: Constant.SECTION_SUBCLIENTS, visible: false },
          ],
        },
        { title: "Reportes", icon: "file", path: Constant.SECTION_REPORTS, visible: false, active: false },
        {
          title: "Administrar",
          icon: "cog",
          active: false,
          visible: false,
          items: [
            { title: "Sucursales", icon: "", path: Constant.SECTION_SUCURSALES, visible: false }, //building
            { title: "Almacenes", icon: "", path: Constant.SECTION_ALMACENES, visible: false }, //warehouse
            { title: "Zonas", icon: "", path: Constant.SECTION_ZONAS, visible: false }, //signs-post
            { title: "Ubicaciones", icon: "", path: Constant.SECTION_UBICACIONES, visible: false }, //signs-post
            { title: "Categorias de zonas", icon: "", path: Constant.SECTION_CATEGORIAS_ZONAS, visible: false }, //layer-group
            { title: "Tipos de ubicaciones", icon: "", path: Constant.SECTION_TIPOS_UBICACIONES, visible: false }, //layer-group
            { title: "Tipos de recepciones", icon: "", path: Constant.SECTION_TIPOS_RECEPCION, visible: false }, //layer-group
            { title: "Tipos de Cubicaje", icon: "", path: Constant.SECTION_CUBICATION_TYPES, visible: false },
            { title: "Muelles", icon: "", path: Constant.SECTION_DOCKS, visible: false },
            { title: "Colaboradores", icon: "", path: Constant.SECTION_EMPLOYEES, visible: false }, //user
            { title: "Operarios", icon: "", path: Constant.SECTION_OPERATORS, visible: false }, //user
            { title: "Roles", icon: "", path: Constant.SECTION_ROLES, visible: false }, //user-cog
            { title: "Configuraciones", icon: "", path: Constant.SECTION_SETTINGS, visible: false }, //user-cog
          ],
        },
      ],
      items: [],
      right: null,
      expandMenu: this.$store.state.sidebar.open ? true : false,
      isMobile: false,
      show: true,
      logo: localStorage.getItem("logo"),
    };
  },
  mounted() {
    this.loadSideBarExternal();
    
    // Inicializar expandMenu según el dispositivo
    if (this.$vuetify.display.mdAndDown) {
      this.expandMenu = this.$store.state.sidebar.drawer;
    } else {
      this.expandMenu = this.$store.state.sidebar.open;
    }
  },
  watch: {
    "$store.state.sidebar.open": function () {
      if (this.$store.state.sidebar.open) {
        this.expandMenu = true;
      } else {
        this.expandMenu = false;
      }
    },
    "$store.state.sidebar.drawer": function () {
      // En mobile, el expandMenu se controla por drawer
      if (this.$vuetify.display.mdAndDown) {
        this.expandMenu = this.$store.state.sidebar.drawer;
      }
    },
  },
  methods: {
    handleExpandMenu(value) {
      // En mobile no expandir automáticamente por hover
      if (this.$vuetify.display.mdAndDown) {
        this.expandMenu = this.$store.state.sidebar.drawer;
        return;
      }
      
      if (this.$store.state.sidebar.open) {
        this.expandMenu = true;
      } else {
        this.expandMenu = value;
      }
    },
    close() {
      // En mobile, cerrar el drawer al hacer click en un item
      if (this.$vuetify.display.mdAndDown) {
        this.$store.commit("setOpenSidebar", {
          open: false,
          drawer: false,
        });
      }
    },
    loadSideBarExternal() {
      this.items = this.getItemsAvailable();
    },
    getItemsSideBar(user_type) {
      let items = [];
      if (this.isClient()) {
        items = this.clientItems;
      }

      if (this.isEmployee()) {
        items = this.allItems;
      }

      return items;
    },
    getItemsAvailable() {
      let user_type = localStorage.getItem("user_type");

      let itemsAvailable = JSON.parse(JSON.stringify(this.getItemsSideBar(user_type)));
      //console.log("ROLES SIDEBAR:", itemsAvailable);

      itemsAvailable.forEach((item) => {
        if ("items" in item) {
          let any_visible = false;
          item.items.forEach((sub_item) => {
            sub_item.visible = sub_item.path.split("/")[0] in this.roles && this.roles[sub_item.path.split("/")[0]].sidebar;
            if (sub_item.visible) any_visible = true;

            //hardcodee para dev
            //sub_item.visible = true;
          });
          item.visible = any_visible;
        } else {
          item.visible = item.path in this.roles && this.roles[item.path].sidebar;
        }
        //hardcodee para dev
        //item.visible = true;
      });
      return itemsAvailable;
    },
  },
};
</script>
